/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const LockCircledIcon = /*#__PURE__*/ createSvgIcon(
  'LockCircledIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <g clipPath={`url(#${id}_0)`}>
            <circle cx={10} cy={10} r={10} fill="#E8EEF7" />
            <path
              d="M6.25 16.125c-.344 0-.638-.122-.883-.367A1.204 1.204 0 015 14.875v-6.25c0-.344.122-.638.367-.883s.54-.367.883-.367h.625v-1.25c0-.865.305-1.602.914-2.21A3.012 3.012 0 0110 3c.865 0 1.602.305 2.21.914.61.61.915 1.346.915 2.211v1.25h.625c.344 0 .638.122.883.367s.367.54.367.883v6.25c0 .344-.122.638-.367.883a1.204 1.204 0 01-.883.367h-7.5zm0-1.25h7.5v-6.25h-7.5v6.25zM10 13c.344 0 .638-.122.883-.367s.367-.54.367-.883c0-.344-.122-.638-.367-.883A1.204 1.204 0 0010 10.5c-.344 0-.638.122-.883.367a1.204 1.204 0 00-.367.883c0 .344.122.638.367.883S9.657 13 10 13zM8.125 7.375h3.75v-1.25c0-.52-.182-.964-.547-1.328A1.808 1.808 0 0010 4.25c-.52 0-.964.182-1.328.547a1.808 1.808 0 00-.547 1.328v1.25z"
              fill="currentColor"
            />
          </g>
          <defs>
            <clipPath id={`${id}_0`}>
              <path fill="#fff" d="M0 0h20v20H0z" />
            </clipPath>
          </defs>
        </>
      ),
    },
  },
  false
);

export default LockCircledIcon;
